import { TileFacet } from '../../catalog/models/tile-facet';
import { CombinedFacets } from '../../facets/models/facet';
import chaining from './chaining';

export default function findTileFacets(facetNames: string[], productFacets: string[], combinedFacets: CombinedFacets): TileFacet[] {
  if (chaining(facetNames, 'length') && chaining(productFacets, 'length') && combinedFacets) {
    const values: TileFacet[] = []
    facetNames.forEach(settingsFacet => {
      const output: TileFacet = {
        name: '',
        values: []
      }
      productFacets.forEach(productFacet => {
        if (productFacet.indexOf(settingsFacet, 0) !== -1) {
          output.name = combinedFacets &&
            combinedFacets.groups &&
            combinedFacets.groups[settingsFacet] &&
            combinedFacets.groups[settingsFacet].name
          const foundValue = combinedFacets && combinedFacets.facets[settingsFacet] && combinedFacets.facets[settingsFacet] &&
            chaining(combinedFacets.facets[settingsFacet].find(item => item.code === productFacet), 'name')
          foundValue && output.values.push(foundValue)
        }
      })
      if (output.values.length) {
        values.push(output)
      }
    })
    return values
  }
  return null
}
